var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9988 13.4462V12.5067C24.9988 7.34839 20.9699 3.16675 16 3.16675C11.0301 3.16675 7.00116 7.34839 7.00116 12.5067V13.4462C7.00116 14.5736 6.67962 15.6758 6.07706 16.6139L4.60048 18.9128C3.25176 21.0125 4.2814 23.8666 6.62715 24.5306C12.7637 26.2677 19.2363 26.2677 25.3729 24.5306C27.7186 23.8666 28.7482 21.0125 27.3995 18.9128L25.9229 16.6139C25.3204 15.6759 24.9988 14.5736 24.9988 13.4462Z",
    stroke: "#303030",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 25.8333C10.8734 28.1636 13.2299 29.8333 16 29.8333C18.7701 29.8333 21.1266 28.1636 22 25.8333",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.5V13.8333",
    stroke: "#303030",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIconBlack);
export default __webpack_public_path__ + "static/media/bell_icon_black.64e9ca230c867dff0e781ece967dd2db.svg";
export { ForwardRef as ReactComponent };